import React from 'react'

const defaultVal = { profile: {} } //Insert the default value here.
export const MainContext = React.createContext(defaultVal);
export default MainContext;